import { render } from "./PerfilHistorialAtenciones.vue?vue&type=template&id=59b84331&scoped=true"
import script from "./PerfilHistorialAtenciones.vue?vue&type=script&lang=js"
export * from "./PerfilHistorialAtenciones.vue?vue&type=script&lang=js"

import "./PerfilHistorialAtenciones.vue?vue&type=style&index=0&id=59b84331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b84331"]])

export default __exports__